import { type FC } from 'react'
import { SelectDropdown, type SelectOption } from '../SelectDropdown/SelectDropdown'
import { useMeetingWorkflowLauncher } from './useMeetingWorkflowLauncher'

export const MeetingWorkflowsMenu: FC = () => {
  const launcher = useMeetingWorkflowLauncher()

  if (!launcher.enabled || (!launcher.isLoading && launcher.workflows.length === 0)) {
    return null
  }

  const options: SelectOption[] = launcher.workflows.map((workflow) => ({ id: workflow.id, label: workflow.name }))
  const onOptionSelected = (option: SelectOption) => launcher.launch(option.id)

  return (
    <>
      <div className='header-dropdown-container d-none d-xl-block position-relative'>
        <SelectDropdown
          label='Workflows'
          icon='bi-stars'
          options={options}
          onOptionSelected={onOptionSelected}
          loading={launcher.isLoading}
          className='zocks-py-0.375 zocks-px-0.75'
        />
      </div>
      <div className='header-dropdown-container d-none d-sm-block d-xl-none'>
        <SelectDropdown
          icon='bi-stars'
          iconOnly
          ariaLabel='Workflows'
          options={options}
          onOptionSelected={onOptionSelected}
          loading={launcher.isLoading}
          className='zocks-py-0.375 zocks-px-0.75'
        />
      </div>
      {launcher.runModal}
    </>
  )
}
